<mat-tab-group>
  <mat-tab label="{{ 'Server' | translate }}">
    <div class="cards">
      <app-card
        label="Server"
        title="Server"
        description="Set up a virtual Windows Server for business use.<br><br>The server will be available exclusively to you, but will be monitored by IT Services."
        moreInformation="https://bernerfachhochschule.sharepoint.com/sites/mybfh-Bernie-RDM-de/SitePages/Windows-Server.aspx"
        image="../assets/images/ServerIcon.svg"
        [formRef]="OrderFormServerComponent"
      ></app-card>
    </div>
  </mat-tab>
</mat-tab-group>
